﻿import $ from "jquery";
import * as utils from "./utils";
import "Fancybox";

const c = {
	arSectionSelector: ".ccs-cc-inline-augmentedreality",
	arFancyBoxContent: ".ccs-inline-ar-fancybox-content",
	qrLightboxDisplayMode: "lightbox",
	qrNoneDisplayMode: "none"
};

var animationList = null;

export default function (ep, options) {
	const $container = ep.find(c.arSectionSelector);

	// in browser without customElements remove block
	if (!window.customElements) {
		$container.remove();
		return;
	}

	const $thumbnailCnt = $container.find(".ccs-inline-ar-thumbnail-cnt");
	const $viewerCnt = $container.find(".ccs-inline-ar-viewer-cnt");
	const $qrCode = $container.find(".ccs-inline-ar-qr-code");
	const $qrCodeButtonBlock = $container.find(".ccs-inline-ar-qr-button");
	const $arBlock = $container.find(".ccs-inline-ar-block ");

	if (options.augmentedReality.autoLoad) {
		loadModelViewer();
	}

	$thumbnailCnt.on("keydown", function (event) {
		if (event.which == 13) {
			$(this).click();
		}
	});

	$thumbnailCnt.on("click",
		() => {
			if (options.augmentedReality.launchInLightbox) {
				var qrCodeScript = "";
				if (isQrCodeVisible()) {
					qrCodeScript = `<div class="ccs-inline-ar-block-qr"><div class ="ccs-inline-ar-qr-code">${$qrCode.html()}</div></div>`;
				}

				var dataElementId = $viewerCnt.closest("[data-elementid]").attr("data-elementid");
				var elementContext = $viewerCnt.closest("[data-context]").attr("data-context");
				var config = {
					content: `<div class='ccs-inline-ar-fancybox-content' tabindex='0' data-elementid=${dataElementId} data-context=${elementContext}>${$viewerCnt.find("script").text()}${qrCodeScript}</div>`,
					type: "html",
					baseClass: "ccs-cc-inline",
					smallBtn: false,
					touch: false,
					afterLoad: function (instance, fbContent) {
						const $viewer = fbContent.$content.find("ccs-model-viewer");
						setViewerHandler($viewer);
						ajustLightBoxSize();
					}
				}
				$.fancybox.open(config);
				return;
			}
			loadModelViewer();
		});


	if (options.augmentedReality.autoLaunchAr) {
		loadModelViewer();

		const $viewer = $viewerCnt.find("ccs-model-viewer");
		$viewer.on("load",
			function () {
				this.activateAR();
				this.shadowRoot.querySelector("#default-ar-button").click();
			});
	} else {
		showQrCode();
	}

	function getErrorMessage(error) {
		return error && error.originalEvent
			? {
				message: error.originalEvent.detail.message,
				type: error.originalEvent.detail.type
			}
			: undefined;
	}

	function loadModelViewer() {
		$thumbnailCnt.hide();
		$viewerCnt.show();

		$viewerCnt.html($viewerCnt.find("script").text());
		const $viewer = $viewerCnt.find("ccs-model-viewer");
		setViewerHandler($viewer);
	}

	function setViewerHandler($viewer) {
		$viewer.on("error", error => {
			utils.dispatchEvent(options.logCall, $viewer, "error", getErrorMessage(error), "Submit");
		});

		$viewer.on("ar-status", event => {
			if (event.detail.status === "not-presenting") {
				$viewer.attr("ar-modes", $viewer.attr("ar-modes").replace("webxr").trim());
				$viewer[0].activateAR();
			}
			if (event.detail.status === "failed") {
				var $error = $viewer.find(".ccs-inline-ar-error");
				$error.removeClass('ccs-inline-ar-error-hide');
				var $close = $viewer.find(".ccs-inline-ar-error-close");
				$close.on("click", function () {
					$error.addClass('ccs-inline-ar-error-hide');
				});

			}
			utils.dispatchEvent(options.logCall, $viewer, "ar-status", { type: event.detail.status });
		});

		utils.dispatchEvent(options.logCall, $viewer, "feature-click", { type: "play" });

		loadAnimation($viewer);
	}

	function loadAnimation(viewer) {
		if (options.augmentedReality.animation == null)
			return;

		// launch animation first time
		var playEvent = options.augmentedReality.animation.playEvent;
		animationList = options.augmentedReality.animation.animationNameList;
		if (playEvent === 'Click') {
			viewer.one('click',
				function () {
					setAnimationName(viewer);
					viewer[0].play();
					setChangeAnimationEvent(viewer);
					utils.dispatchEvent(options.logCall, viewer, "feature-click", { type: "animationStart" });
				});
		} else if (playEvent === 'DoubleClick') {
			viewer.one('dblclick',
				function () {
					setAnimationName(viewer);
					viewer[0].play();
					setChangeAnimationEvent(viewer);
					utils.dispatchEvent(options.logCall, viewer, "feature-click", { type: "animationStart" });
				});
		}
		else {
			var delay = options.augmentedReality.animation.delay;
			if (delay != null) {
				setTimeout(function () {
					launchAutoplayAnimation(viewer);
				}, delay);
			} else {
				launchAutoplayAnimation(viewer);
			}
		}
	}

	function setChangeAnimationEvent(viewer) {
		var changeEvent = options.augmentedReality.animation.changeEvent;
		if (changeEvent == 'Action') {
			viewer.on('click',
				function () {
					setAnimationName(viewer);
				});
		} else {
			var delay = options.augmentedReality.animation.delay;
			if (delay != null) {
				setInterval(function () {
					setAnimationName(viewer);
				}, delay);
			}
		}
	}

	function setAnimationName(viewer) {
		if (animationList == null || animationList.length === 0) {
			animationList = viewer[0].availableAnimations;
		}

		if (!viewer.attr('animation-name')) {
			viewer.attr('animation-name', animationList[0]);
			return;
		}

		var currentAnimationNameIndex = animationList.indexOf(viewer.attr('animation-name'));
		var newAnimationName = currentAnimationNameIndex == animationList.length - 1
			? options.augmentedReality.animation.repeat === true ? animationList[0] : null
			: animationList[currentAnimationNameIndex + 1];

		if (newAnimationName != null)
			viewer.attr('animation-name', newAnimationName);
		else {
			viewer[0].pause();
			viewer[0].currentTime = 0;
		}
	}

	function launchAutoplayAnimation(viewer) {
		setAnimationName(viewer);
		viewer.attr("autoplay", true);
		setChangeAnimationEvent(viewer);
	}

	function ajustLightBoxSize() {
		var arSize = calculateViewerSize();

		if (isQrCodeVisible()) {
			var qrWidth = $qrCode.width() / window.innerWidth * 100;

			if (qrWidth > arSize.width) {
				arSize.width = qrWidth;
			}
		}

		$(c.arFancyBoxContent)
			.css("width", `${arSize.width}vw`);

		const $viewer = $(c.arFancyBoxContent).find(".ccs-inline-ar-viewer");
		$viewer.css("height", `${arSize.height}vh`).css("margin", "auto");
	}

	function getDefaultAspectRatio() {
		return window.innerWidth / window.innerHeight;
	}

	function calculateViewerSize() {
		var mobile = navigator.maxTouchPoints && navigator.maxTouchPoints > 0;
		var ar = options.augmentedReality.aspectRatio == undefined
			|| options.augmentedReality.aspectRatio == 0
			? getDefaultAspectRatio() : options.augmentedReality.aspectRatio;

		var height = $arBlock.height() / window.innerHeight * 100;
		var width = height / ar;

		if (mobile && window.innerWidth > window.innerHeight ) {
			return { width: width, height: getSize(window.innerHeight)};
		}

		if (mobile) {
			return { width: getSize(window.innerWidth), height: height };
		}
		return { width: width, height: height };
	}

	function getSize(s) {
		return s > 600 ? 80 : 100;
	}

	if (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) {
		window.addEventListener("resize", ajustLightBoxSize);
	}

	function showQrCode() {
		if (!isQrCodeVisible())
			return;

		if (options.augmentedReality.qrDisplayMode === c.qrLightboxDisplayMode && !options.augmentedReality.launchInLightbox) {
			$qrCodeButtonBlock.show();
			$qrCodeButtonBlock.on("click",
				function () {
					var config = {
						content: `<div class='ccs-inline-ar-fancybox-content' tabindex='0'><div class="ccs-inline-ar-qr-code"">${$qrCode.html()}</div></div>`,
						type: "html",
						baseClass: "ccs-cc-inline",
						smallBtn: false,
						touch: false
					}
					$.fancybox.open(config);
					return;
				});
		} else {
			$qrCode.show();
		}
	}

	function isQrCodeVisible() {
		return options.augmentedReality.qrDisplayMode !== c.qrNoneDisplayMode && !ccs_util.isMobile();
	}
}